import { useTranslation } from 'react-i18next';
import { shopProfileTranslations } from '../translations/shopProfileTranslations';

export const useShopProfileTranslation = () => {
  const { i18n } = useTranslation();
  
  // Get current language, fallback to English if not supported
  const currentLang = ['en', 'fr', 'es', 'ar'].includes(i18n.language) 
    ? i18n.language 
    : 'en';
  
  // RTL support for Arabic
  const isArabic = currentLang === 'ar';
  const rtlDirection = isArabic ? 'rtl' : 'ltr';
  
  // Translation function that uses our dedicated translations
  const t = (key) => {
    return shopProfileTranslations[currentLang][key] || shopProfileTranslations.en[key] || key;
  };
  
  return {
    t,
    i18n,
    currentLanguage: currentLang,
    isArabic,
    rtlDirection
  };
};
